import { getCustomerGrowth } from "@/services/v1/analyticsAPIService";

export default {
  state: {
    customerGrowthPeriod: null,
    customerCurrentCount: 0,
    customerGrowthRate: 0,
  },
  getters: {
    customerGrowthPeriod: (state) => state.customerGrowthPeriod,
    customerCurrentCount: (state) => state.customerCurrentCount,
    customerGrowthRate: (state) => state.customerGrowthRate,
  },
  mutations: {
    SET_CUSTOMER_GROWTH(state, data) {
      state.customerGrowthPeriod = data.period;
      state.customerCurrentCount = data.current_count;
      state.customerGrowthRate = data.growth_rate;
    },
  },
  actions: {
    async fetchCustomerGrowth({ commit }, { period = null } = {}) {
      try {
        const response = await getCustomerGrowth(period);
        commit("SET_CUSTOMER_GROWTH", response);
      } catch (error) {
        console.error("Error fetching customer growth:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
  },
};
